var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonLink } from '@marketing/components/global/CTA/Button';
import ProductTile from '@marketing/components/global/tile/ProductTile';
import Heading from '@marketing/components/global/typography/Heading';
import { useCallback, useState } from 'react';
import { Link } from 'react-router';
import { sendGTMClickToPDPEvent } from '@trackers';
function ProductList(_a) {
    var title = _a.title, products = _a.products, viewAllUrl = _a.viewAllUrl;
    var _b = useState(null), calculatedTileWidth = _b[0], setCalculatedTileWidth = _b[1];
    var onTileResize = useCallback(function (width) {
        if (calculatedTileWidth !== width) {
            setCalculatedTileWidth(width);
        }
    }, [calculatedTileWidth]);
    var initialTileWidth = 212; // Default width for the tile
    var initialColumnGap = 20; // Default gap between columns in pixels
    var minTileWidth = 144;
    return (_jsxs("div", __assign({ className: "flex flex-col justify-start items-start gap-y-md-m gap-x-xl-m" }, { children: [_jsxs("div", __assign({ className: "flex items-center gap-sm-gutter" }, { children: [_jsx(Heading, __assign({ tabbable: true, size: "sm", className: "text-text-body" }, { children: title })), viewAllUrl && (_jsx(ButtonLink, __assign({ size: "mini", use: "outline", href: viewAllUrl, className: "hover:no-underline" }, { children: "View All" })))] })), _jsx("div", __assign({ style: {
                    gridTemplateColumns: "repeat(".concat(products.length, ", minmax(").concat(minTileWidth, "px, ").concat(initialTileWidth, "px))"),
                    columnGap: "".concat((initialColumnGap / initialTileWidth) * calculatedTileWidth || initialTileWidth, "px"),
                }, className: "grid h-[225px] w-full gap-y-md-m" }, { children: products.map(function (_a) {
                    var productId = _a.productId, image = _a.image, tileDisplayName = _a.tileDisplayName, url = _a.url;
                    return (_jsx(Link, __assign({ to: url, viewTransition: true, className: "hover:no-underline", onClick: function () { return sendGTMClickToPDPEvent(productId, 'navbar'); } }, { children: _jsx(ProductTile, { onResize: onTileResize, useHoverOverlay: true, image: {
                                src: image.src,
                                alt: image.alt,
                            }, label: tileDisplayName }) }), tileDisplayName));
                }) }))] })));
}
export default ProductList;
